export default __webpack_public_path__ + "static/media/deaceroLogo.119a66bc.PNG";